import CryptoJs from "crypto-js";

const HPPcode = process.env.REACT_APP_HPP_CODE;

export const generateHash = (params) => {
  // Convert params object to an array of values in the specified order
  const inputArray = Object.values(params);
  // console.log(params)
  // Concatenate the parameter values into a single string
  const input = inputArray.join("");

  // Create the salted input
  const saltedInput = HPPcode + input;

  // Generate SHA-256 hash and convert to hexadecimal
  const sha256Hash = CryptoJs.SHA256(saltedInput);
  const hexHash = sha256Hash.toString(CryptoJs.enc.Hex);

  return hexHash;
};
